
import { Sortable, MultiDrag } from "sortablejs";
import draggable from "vuedraggable";
import { FormApi } from "@/services/api/Form.service";
import { getLookups } from "@/services/api/Lookup.service";
import {
  defineComponent,
  onMounted,
  ref,
  toRef,
  computed,
  watch,
  nextTick,
} from "vue";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import { TranslationService } from "@/core/services/TranslationService";
import { useForm, useIsFormValid, useValidateForm } from "vee-validate";
import { Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { hideModal } from "@/core/helpers/dom";
import { ISearch } from "@/interfaces/iSavedFilter";
import { MenuComponent } from "@/assets/ts/components";
import VZMultiSelect from "@/components/modals/forms/VZMultiSelect.vue";
import { useToast } from "vue-toastification";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { IFormSections } from "@/interfaces/iForm";
import FormSectionModal from "@/views/form/modal/SectionDetailModal.vue";
import { Modal } from "bootstrap";
import AddEditModal from "@/components/modals/forms/AddEditModal.vue";
import moment from "moment-timezone";
interface Step1 {
  formName: string;
}

type KTCreateApp = Step1;
interface FormSectionGlobalModel {
  formSectionLocationModels: FormSectionLocationModel[];
}
interface FormSectionLocationModel {
  sectionId: number;
  siteId?: number;
  locationId?: number;
  sequence?: number;
}
import { FormatMethods, getMaxLengthErrorMessage } from "@/helpers/data-format";
import { IDataTableFilterOptionOptions } from "@/interfaces/iPageModel";
import { LocationAPI } from "@/services/api/Location.service";
import { ILocation } from "@/interfaces/iLocation";
import { IAddEditFormModel } from "@/interfaces/iAddEditFormModel";
import { SectionDesignAPI } from "@/services/api/SectionDesign.service";
import { Actions } from "@/store/enums/StoreEnums";
import store from "@/store";
Sortable.mount(new MultiDrag());
export default defineComponent({
  name: "create-form-modal",
  components: {
    Field,
    ErrorMessage,
    draggable,
    VZMultiSelect,
    Datepicker,
    FormSectionModal,
    AddEditModal,
  },
  emits: ["on-submit"],
  props: {
    singleForm: {
      type: Object,
      default: null,
    },
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const toast = useToast();
    const submitButton = ref<HTMLButtonElement | null>(null);
    const addMessage = t("pages.form.formAddedMessage");
    const editMessage = t("pages.form.formUpdatedMessage");
    const noSelectedBranchMsg = t("pages.form.selectAtLeastOne");
    const sectionLocation = ref<Array<FormSectionLocationModel>>([]);
    const selectedSection = ref<IFormSections>({
      webId: 0,
      name: "",
      status: "",
      locationName: "",
      locationCode: 0,
      locationCodeText: "",
      sequence: 0,
      recordHistory: false,
      locationRestriction: false,
      template: false,
      formDefinitionId: 0,
      formSectionId: 0,
    });

    const edit_form = ref<boolean>(false);
    const idGlobal = ref(8);
    const order = ref(4);
    const list1 = ref<Array<any>>([]);
    const movedListSearch = ref<Array<any>>([]);
    const list2 = ref<IFormSections[]>([]);
    const showDetailDialog = ref<any>(false);
    const first_screen_booleans = ref<Array<string>>([]);
    const singleFormToEdit = toRef(props, "singleForm");
    const controlOnStart = ref(true);
    const _stepperObj = ref<StepperComponent | null>(null);
    const formCategories = ref([]);
    const itemsTemplates = ref([]);
    const itemsReceipents = ref([]);
    const createAppRef = ref<HTMLElement | null>(null);
    const createEventModalRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(1);
    const startDate = ref("");
    const allFormSections = ref({});
    const allFormSites = ref([]);
    const allSelectedFormSites = ref({});
    const allFormRoles = ref<any>([]);
    const allFormUsers = ref<any>([]);
    const allFormRolesFilter = ref<any>([]);
    const allFormUsersFilter = ref<any>([]);
    const allFormEvents = ref([]);
    const searchTermEvents = ref<string>("");
    const searchTermRoles = ref<string>("");
    const searchTermUsers = ref<string>("");
    const searchTermSites = ref<string>("");
    const searchTermSections = ref<string>("");
    const searchSections = ref<string>("");
    const loading = ref<boolean>(false);
    const loadingUsers = ref<boolean>(false);
    const savedFilterList = ref<Array<ISearch>>([]);
    let searchableFilterList = ref<Array<ISearch>>([]);
    let sectionList = ref<Array<ISearch>>([]);
    const locationOption = ref<{ label: string; value: string }[]>([]);
    const moveAllForward = ref();
    const moveAllBackward = ref();
    const frequencyOptions = ref<IDataTableFilterOptionOptions[]>([]);
    const showAddLocationModal = ref(false);
    const userSiteModelData = ref({
      header: "Location",
      page: "Location",
      edit: false,
      data: { siteId: "", locationId: "", locationRestriction: false },
      label: [{ addHeader: t("pages.location.assignLocation") }],
      model: [
        {
          name: "siteId",
          label: t("pages.site.title"),
          type: "list",
          required: false,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: "Please select branch",
          options: [],
        },
        {
          name: "locationId",
          label: t("pages.location.location"),
          type: "list",
          required: false,
          showOnlyInEdit: false,
          disabled: false,
          placeholder: "Please select location",
          options: locationOption.value ?? [],
        },
      ],
    });
    const selectedSiteOptions = computed(() => {
      return allFormSites.value
        .filter((site: any) =>
          post_form_data.value.formSiteGlobalModel.siteIds.includes(site.webId)
        )
        .map((site: any) => ({
          label: site.name,
          value: site.webId,
        }));
    });
    const computedUserSiteModalData = computed(() => {
      return {
        ...userSiteModelData.value,
        model: userSiteModelData.value.model.map((model) => {
          if (model.name === "siteId") {
            return { ...model, options: selectedSiteOptions.value };
          }
          if (model.name === "locationId") {
            return { ...model, options: locationOption.value ?? [] };
          }
          return model;
        }),
      };
    });
    const fetchLocationsList = async (id) => {
      if (userSiteModelData.value.edit || id) {
        // Fetch locations for the selected siteId
        const data = await LocationAPI.getInstance().getLocationList({
          page: 0,
          size: 1000,
          siteId: id || "",
        });

        locationOption.value = data.content.map((item: ILocation) => {
          return {
            label: item.name,
            value: `${item.webId}`,
          };
        });
      }
    };
    const post_form_data = ref({
      webId: ref<number>(),
      startDate: "",
      endDate: "",
      name: "",
      frequency: "",
      locationRestrict: false,
      sequence: false,
      status: "Active",
      formCategoryGlobalModel: {
        categoryCode: ref<any | any[]>(null),
      },
      formSectionGlobalModel: ref<FormSectionGlobalModel>({
        formSectionLocationModels: [],
      }),
      formSiteGlobalModel: {
        siteIds: ref<Array<number>>([]),
      },
      formEventGlobalModel: {
        eventIds: ref<Array<number>>([]),
      },
      formUserGlobalModel: {
        formUsers: ref([]) as any,
      },
      formUserGlobalModelDummy: {
        userIds: ref<Array<number>>([]),
      },
      formRoleGlobalModel: {
        roleIds: ref<Array<number>>([]),
      },
    });
    const sitesKeyword = ref("");

    const formData = ref<KTCreateApp>({
      formName: "",
    });
    interface categoriesData {
      categories: Array<string>;
    }
    const targetCategories = ref<categoriesData>({
      categories: [],
    });
    const sectionMoveSelected = ref<Array<number>>([]);
    const sectionBackSelected = ref<Array<number>>([]);
    const sectionSelectedForLocation = ref<number>();
    // const dataCommunicationMode = "";
    const statusOptions = [
      {
        label: t("common.active"),
        value: "Active",
      },
      {
        label: t("common.inactive"),
        value: "Inactive",
      },
    ];
    const createAppSchema = [
      Yup.object({
        formName: Yup.string()
          .strict(true)
          .max(30, getMaxLengthErrorMessage(t("common.name"), 30))
          .required(t("common.name") + " " + t("common.isRequired"))
          .matches(/\S/, t("common.name") + " " + t("common.isRequired")),
        startDate: Yup.date()
          .nullable()
          .transform((curr, orig) => (orig === "" ? null : curr))
          .required(t("common.startDate") + " " + t("common.isRequired")),
        endDate: Yup.date()
          .transform((curr, orig) => (orig === "" ? null : curr))
          .min(Yup.ref("startDate"), t("validation.greaterEndDate"))
          .nullable(),
        categoryCode: Yup.array()
          .of(Yup.number().required())
          .min(1, t("pages.form.category") + " " + t("common.isRequired"))
          .required(t("pages.form.category") + " " + t("common.isRequired"))
          .nullable(),

        // frequency: Yup.string()
        //   .nullable()
        //   .required(t("pages.form.frequency") + " " + t("common.isRequired")),
      }),
    ];

    // extracts the individual step schema
    const currentSchema = computed(() => {
      return createAppSchema[currentStepIndex.value - 1];
    });
    const displayDate = computed(() => {
      return process.env.VUE_APP_DATE_PICKER_FORMAT || "MM-dd-yyyy";
    });
    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });
    const format = computed(() => {
      return FormatMethods;
    });
    const { handleSubmit, resetForm } = useForm<Step1>({
      validationSchema: currentSchema,
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const openDetailModal = async (formSection) => {
      showDetailDialog.value = true;
      const sectionData = await SectionDesignAPI.getInstance().getSectionDetail(
        formSection?.formSectionId ?? formSection.webId
      );
      selectedSection.value = sectionData;
    };

    const handleStep = handleSubmit((values) => {
      if (currentStepIndex.value == 2) {
        if (post_form_data.value.formSiteGlobalModel.siteIds.length == 0) {
          toast.error(noSelectedBranchMsg);
          return;
        } else {
          getAllFormUsersAndRoles();
        }
      }
      if (currentStepIndex.value > 6) {
        return;
      }

      formData.value = {
        ...formData.value,
        ...values,
      };

      if (currentStepIndex.value != 6) {
        currentStepIndex.value++;
      }

      if (!_stepperObj.value) {
        return;
      }

      _stepperObj.value.goNext();
    });
    const closeModal = async () => {
      var appElement = document.getElementById("app");
      if (appElement) {
        appElement.click();
      }
      searchTermEvents.value = "";
      searchTermRoles.value = "";
      searchTermUsers.value = "";
      searchTermSites.value = "";
      searchTermSections.value = "";
      searchSections.value = "";
      getAllFormSections();
      getAllFormSites();
      getAllFormEvents();
      filterFormUsers();
      filterFormRoles();
      searchSectionFilters();
      resetAllFormValues();
      await nextTick();
      await resetForm();
    };

    const selectAll = (element) => {
      if (element.srcElement.checked) {
        post_form_data.value.formRoleGlobalModel.roleIds =
          allFormRolesFilter.value.map(
            (obj: any) => obj.siteId.toString() + obj.userRoleId.toString()
          );
      } else {
        post_form_data.value.formRoleGlobalModel.roleIds = [];
      }
    };
    const selectAllSites = (element) => {
      if (element.srcElement.checked) {
        post_form_data.value.formSiteGlobalModel.siteIds =
          allFormSites.value.map((data: any) => data.webId);
      } else {
        post_form_data.value.formSiteGlobalModel.siteIds = [];
      }
    };

    const selectAllUsers = (element) => {
      if (element.srcElement.checked) {
        post_form_data.value.formUserGlobalModelDummy.userIds =
          allFormUsersFilter.value.map(
            (obj: any) => obj.siteId.toString() + obj.userRoleId.toString()
          );
      } else {
        post_form_data.value.formUserGlobalModelDummy.userIds = [];
      }
    };

    const minEndDate = computed(() => {
      const today = moment().format("YYYY-MM-DD");
      const startDate = moment(post_form_data.value.startDate).format(
        "YYYY-MM-DD"
      );
      if (today >= startDate) {
        return today;
      } else {
        return startDate;
      }
    });

    const selectAllEvents = (element) => {
      if (element.srcElement.checked) {
        post_form_data.value.formEventGlobalModel.eventIds =
          allFormEvents.value.map((data: any) => data.webId);
      } else {
        post_form_data.value.formEventGlobalModel.eventIds = [];
      }
    };

    const resetAllFormValues = async () => {
      post_form_data.value = {
        webId: 1,
        startDate: "",
        endDate: "",
        name: "",
        frequency: "",
        locationRestrict: false,
        sequence: false,
        status: "Active",
        formCategoryGlobalModel: {
          categoryCode: null,
        },
        formSectionGlobalModel: {
          formSectionLocationModels: [],
        },
        formSiteGlobalModel: {
          siteIds: [],
        },
        formEventGlobalModel: {
          eventIds: [],
        },
        formUserGlobalModel: {
          formUsers: [],
        },
        formUserGlobalModelDummy: {
          userIds: [],
        },
        formRoleGlobalModel: {
          roleIds: [],
        },
      };
      list1.value = [];
      allFormRolesFilter.value = [];
      allFormUsersFilter.value = [];
      first_screen_booleans.value = [];

      // _stepperObj.value?.goto(1);
    };
    const formSubmit = async () => {
      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }
      if (post_form_data.value.formEventGlobalModel.eventIds.length > 0) {
        if (
          post_form_data.value.formRoleGlobalModel.roleIds.length == 0 &&
          post_form_data.value.formUserGlobalModelDummy.userIds.length == 0
        ) {
          toast.error(
            "If you want to assign Event then atleast one user/role should be selected"
          );
          if (submitButton.value) {
            // eslint-disable-next-line
            submitButton.value!.disabled = false;
            // Activate indicator
            submitButton.value.setAttribute("data-kt-indicator", "off");
          }
          return;
        }
      }

      list1.value.forEach((value, index) => {
        //
        post_form_data.value.formSectionGlobalModel.formSectionLocationModels.push(
          {
            sectionId: value?.formSectionId ?? value.webId,
            siteId: value?.siteId,
            locationId: value?.locationId,
            sequence: index,
          }
        );
      });
      let message = edit_form.value ? editMessage : addMessage;
      if (singleFormToEdit.value.name) {
        if (post_form_data.value.formRoleGlobalModel.roleIds.length > 0) {
          let roleIds = post_form_data.value.formRoleGlobalModel.roleIds;
          let uniqueRoleIds = Array.from(new Set(roleIds)) as number[];
          post_form_data.value.formRoleGlobalModel.roleIds = uniqueRoleIds;
        }
        if (post_form_data.value.formSiteGlobalModel.siteIds.length > 0) {
          let siteIds = post_form_data.value.formSiteGlobalModel.siteIds;
          let uniqueIds = Array.from(new Set(siteIds)) as number[];
          post_form_data.value.formSiteGlobalModel.siteIds = uniqueIds;
        }
        if (post_form_data.value.formUserGlobalModelDummy.userIds.length > 0) {
          let userIds = post_form_data.value.formUserGlobalModelDummy.userIds;
          let uniqueIds = Array.from(new Set(userIds));
          post_form_data.value.formUserGlobalModelDummy.userIds = uniqueIds;
          // singleFormToEdit.value.formUserGlobalModel.userIds = uniqueIds;
        }
        const extractedArrayRole = allFormRolesFilter.value
          .filter((obj) =>
            post_form_data.value.formRoleGlobalModel.roleIds.some(
              (id) => id == obj.siteId.toString() + obj.userRoleId.toString()
            )
          )
          .map((obj) => ({ siteId: obj.siteId, roleId: obj.userRoleId }));
        const extractedArray = allFormUsersFilter.value
          .filter((obj) =>
            post_form_data.value.formUserGlobalModelDummy.userIds.some(
              (id) => id == obj.siteId.toString() + obj.userRoleId.toString()
            )
          )
          .map((obj) => ({ siteId: obj.siteId, userId: obj.userRoleId }));
        let bothArrays = [...extractedArray, ...extractedArrayRole];
        post_form_data.value.formUserGlobalModel.formUsers = bothArrays;
        // if ("formUserGlobalModelDummy" in post_form_data.value) {
        //   delete (post_form_data.value as any).formUserGlobalModelDummy;
        // }
        let payload = { ...post_form_data.value };
        if ("formUserGlobalModelDummy" in payload) {
          delete (payload as any).formUserGlobalModelDummy;
        }
        // if ("formRoleGlobalModel" in payload) {
        //   delete (payload as any).formUserGlobalModelDummy;
        // }
        payload.formRoleGlobalModel.roleIds = [];

        const dateFormat = "YYYY-MM-DDTHH:mm:ssZ";
        const startMoment = moment(payload.startDate).startOf("day");
        const formattedStartDate = startMoment.format(dateFormat);
        payload.startDate = formattedStartDate;
        if (payload.endDate) {
          const endMoment = moment(payload.endDate).endOf("day");
          const formattedEndDate = endMoment.format(dateFormat);
          payload.endDate = formattedEndDate;
        }

        if ("status" in payload) {
          delete (payload as any).status;
        }
        await FormApi.getInstance()
          .addForm(payload, edit_form.value)
          .then(() => {
            toast.success(message);
            emit("on-submit");
            const deleteModal = document.querySelector(
              `#kt_modal_create_form`
            ) as HTMLElement;
            hideModal(deleteModal);
            edit_form.value = false;
            resetAllFormValues();
          })
          .catch(() => {
            //
          })
          .finally(() => {
            //loading.value = false;
            if (submitButton.value) {
              // eslint-disable-next-line
              submitButton.value!.disabled = false;
              // Activate indicator
              submitButton.value.setAttribute("data-kt-indicator", "off");
            }
          });
      } else {
        if (
          post_form_data.value.formUserGlobalModelDummy.userIds &&
          post_form_data.value.formUserGlobalModelDummy.userIds.length > 0
        ) {
          let userIds = post_form_data.value.formUserGlobalModelDummy.userIds;
          let uniqueIds = Array.from(new Set(userIds));
          post_form_data.value.formUserGlobalModelDummy.userIds = uniqueIds;
          // singleFormToEdit.value.formUserGlobalModel.userIds = uniqueIds;
        }
        const extractedArrayRole = allFormRolesFilter.value
          .filter((obj) =>
            post_form_data.value.formRoleGlobalModel.roleIds.some(
              (id) => id == obj.siteId.toString() + obj.userRoleId.toString()
            )
          )
          .map((obj) => ({ siteId: obj.siteId, roleId: obj.userRoleId }));
        const extractedArray = allFormUsersFilter.value
          .filter((obj) =>
            post_form_data.value.formUserGlobalModelDummy.userIds.some(
              (id) => id == obj.siteId.toString() + obj.userRoleId.toString()
            )
          )
          .map((obj) => ({ siteId: obj.siteId, userId: obj.userRoleId }));
        let bothArrays = [...extractedArray, ...extractedArrayRole];
        post_form_data.value.formUserGlobalModel.formUsers = bothArrays;
        delete post_form_data.value.webId;
        // if ("formUserGlobalModelDummy" in post_form_data.value) {
        //   delete (post_form_data.value as any).formUserGlobalModelDummy;
        // }
        let payload = { ...post_form_data.value };
        if ("formUserGlobalModelDummy" in payload) {
          delete (payload as any).formUserGlobalModelDummy;
        }
        payload.formRoleGlobalModel.roleIds = [];

        const dateFormat = "YYYY-MM-DDTHH:mm:ssZ";
        const startMoment = moment(payload.startDate).startOf("day");
        const formattedStartDate = startMoment.format(dateFormat);
        payload.startDate = formattedStartDate;
        if (payload.endDate) {
          const endMoment = moment(payload.endDate).endOf("day");
          const formattedEndDate = endMoment.format(dateFormat);
          payload.endDate = formattedEndDate;
        }
        if ("status" in payload) {
          delete (payload as any).status;
        }
        await FormApi.getInstance()
          .addForm(payload, edit_form.value)
          .then(() => {
            toast.success(message);
            emit("on-submit");
            const deleteModal = document.querySelector(
              `#kt_modal_create_form`
            ) as HTMLElement;
            hideModal(deleteModal);
            edit_form.value = false;
            resetAllFormValues();
          })
          .catch(() => {
            //
          })
          .finally(() => {
            //loading.value = false;
            if (submitButton.value) {
              // eslint-disable-next-line
              submitButton.value!.disabled = false;
              // Activate indicator
              submitButton.value.setAttribute("data-kt-indicator", "off");
            }
          });
      }
      closeModal();
    };
    const checkLocationBoolean = async (event) => {
      if (event.target.checked) {
        post_form_data.value.locationRestrict = true;
      } else {
        post_form_data.value.locationRestrict = false;
      }
    };

    const checkSequenceFormBoolean = async (event) => {
      if (event.target.checked) {
        post_form_data.value.sequence = true;
      } else {
        post_form_data.value.sequence = false;
      }
    };
    const getCategoryLookup = async () => {
      await getLookups(
        "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKFormsCategory"
      )
        .then((res: any) => {
          formCategories.value = res;
        })
        .catch((err) => {
          return [];
        });
    };
    const getAllFormSites = async () => {
      if (searchTermSites.value) {
        loading.value = true;
        await getLookups(
          "site/sites/all?status=ACTIVE&search=" + searchTermSites.value
        )
          .then((res: any) => {
            setTimeout(() => {
              loading.value = false;
              allFormSites.value = res;
            }, 1000);
          })
          .catch((err) => {
            return [];
          });
      } else {
        await getLookups("site/sites/all?status=ACTIVE")
          .then((res: any) => {
            allFormSites.value = res;
          })
          .catch((err) => {
            return [];
          });
      }
    };

    const filterFormRoles = () => {
      if (searchTermRoles.value != "") {
        allFormRolesFilter.value = [];
        allFormRoles.value.map((role) => {
          if (
            role.userRoleName
              .toLowerCase()
              .includes(searchTermRoles.value.toLowerCase())
          ) {
            allFormRolesFilter.value.push(role);
          }
        });
      } else {
        allFormRolesFilter.value = [];
        allFormRolesFilter.value = [...allFormRoles.value];
      }
    };

    const filterFormUsers = () => {
      if (searchTermUsers.value != "") {
        allFormUsersFilter.value = [];
        allFormUsers.value.map((role) => {
          if (
            role.userRoleName
              .toLowerCase()
              .includes(
                searchTermUsers.value.toLowerCase() ||
                  role.email
                    .toLowerCase()
                    .includes(searchTermUsers.value.toLowerCase())
              )
          ) {
            allFormUsersFilter.value.push(role);
          }
        });
      } else {
        allFormUsersFilter.value = [];
        allFormUsersFilter.value = [...allFormUsers.value];
      }
    };

    const getAllFormUsersAndRoles = async () => {
      if (searchTermRoles.value) {
        loadingUsers.value = true;
        // store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
        await getLookups(
          `site/userSites/userAndRole?paramSiteIds=${post_form_data.value.formSiteGlobalModel.siteIds}&search=${searchTermRoles.value}`
        )
          .then((res: any) => {
            setTimeout(() => {
              loadingUsers.value = false;
              allFormUsers.value = res.filter((data) => data.type == "USER");
              allFormRoles.value = res.filter((data) => data.type == "ROLE");
              allFormUsersFilter.value = [...allFormUsers.value];
              allFormRolesFilter.value = [...allFormRoles.value];
              // store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
            }, 1000);
          })
          .catch((err) => {
            return [];
          });
      } else {
        // store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
        await getLookups(
          `site/userSites/userAndRole?paramSiteIds=${post_form_data.value.formSiteGlobalModel.siteIds}`
        )
          .then((res: any) => {
            allFormUsers.value = res.filter((data) => data.type == "USER");
            allFormRoles.value = res.filter((data) => data.type == "ROLE");
            allFormUsersFilter.value = [...allFormUsers.value];
            allFormRolesFilter.value = [...allFormRoles.value];
            // store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          })
          .catch((err) => {
            return [];
          });
      }
    };
    const getAllFormEvents = async () => {
      if (searchTermEvents.value) {
        loading.value = true;
        await getLookups(
          "notification/events/all?status=ACTIVE&subType=EVENT_FORM&search=" +
            searchTermEvents.value
        )
          .then((res: any) => {
            setTimeout(() => {
              loading.value = false;
              allFormEvents.value = res;
            }, 1000);
          })
          .catch((err) => {
            return [];
          });
      } else {
        await getLookups(
          "notification/events/all?status=ACTIVE&subType=EVENT_FORM"
        )
          .then((res: any) => {
            allFormEvents.value = res;
          })
          .catch((err) => {
            return [];
          });
      }
    };
    const clone = async ({ name }) => {
      return { name, id: idGlobal.value++ };
    };
    const pullFunction = async () => {
      return controlOnStart.value ? "clone" : true;
    };
    const start = async ({ originalEvent }) => {
      // controlOnStart.value = originalEvent.ctrlKey;
    };
    const getAllFormSections = async () => {
      let fetchedSections: IFormSections[] = [];
      if (searchTermSections.value) {
        loading.value = true;
        await getLookups(
          "forms/sections/list?search=" + searchTermSections.value
        )
          .then((res: any) => {
            loading.value = false;
            fetchedSections = res;
          })
          .catch((err) => {
            return [];
          });
      } else {
        await getLookups("forms/sections/list")
          .then((res: any) => {
            fetchedSections = res;
          })
          .catch((err) => {
            return [];
          });
      }

      // Always filter out already selected sections
      const selectedIds = list1.value.map(
        (item) => item.formSectionId ?? item.webId
      );
      list2.value = fetchedSections.filter(
        (item) => !selectedIds.includes(item.webId)
      );
    };

    resetForm({
      values: {
        ...formData.value,
      },
    });

    onMounted(async () => {
      _stepperObj.value = StepperComponent.createInsance(
        createAppRef.value as HTMLElement
      );
      getCategoryLookup();
      getAllFormSections();
      getAllFormSites();
      getAllFormEvents();
      try {
        const options = await getLookups(
          "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKFormsFrequency"
        );
        frequencyOptions.value = options.map((option) => {
          return {
            label: `${option.value}`,
            value: `${option.text}`,
          };
        });
        // const data = await LocationAPI.getInstance().getLocationList({
        //   page: 0,
        //   size: 1000,
        // });

        // locationOption.value = data.content.map((item: ILocation) => {
        //   return {
        //     label: item.name,
        //     value: `${item.webId}`,
        //   };
        // });
      } catch (error) {
        console.log(error);
      }
    });
    const isValid = useIsFormValid();
    const moveToSpecificStep = async (step: number) => {
      if (
        step > 2 &&
        post_form_data.value.formSiteGlobalModel.siteIds.length == 0
      ) {
        toast.error(noSelectedBranchMsg);
        return;
      }
      if (
        !_stepperObj.value ||
        !edit_form.value ||
        step === currentStepIndex.value
      ) {
        return;
      }
      await useValidateForm();
      if (!isValid.value) {
        return;
      }
      currentStepIndex.value = step;
      _stepperObj.value?.goto(step);
    };
    const checkCategories = async (categories) => {
      if (categories.length > 0) {
        const categoryCodeArray =
          post_form_data?.value.formCategoryGlobalModel?.categoryCode;

        if (categoryCodeArray === null) {
          post_form_data.value.formCategoryGlobalModel.categoryCode = [];
        }
        const arrayToPush = Array.isArray(categoryCodeArray)
          ? categoryCodeArray
          : [categoryCodeArray];

        categories.forEach((value, index) => {
          arrayToPush.push(value.categoryCode);
        });

        post_form_data.value.formCategoryGlobalModel.categoryCode = arrayToPush;
      }
    };

    const checkRoles = async (roles) => {
      post_form_data.value.formRoleGlobalModel.roleIds = [];
      roles.forEach((value) => {
        // Format should match: siteId.toString() + userRoleId.toString()
        const formattedId =
          typeof value === "object"
            ? value.siteId.toString() + value.roleId.toString()
            : value.toString();
        post_form_data.value.formRoleGlobalModel.roleIds.push(formattedId);
      });
      // Force reactivity
      post_form_data.value.formRoleGlobalModel.roleIds = [
        ...post_form_data.value.formRoleGlobalModel.roleIds,
      ];
    };
    const checkUsers = async (users) => {
      post_form_data.value.formUserGlobalModelDummy.userIds = [];
      users.forEach((value) => {
        // Format should match: siteId.toString() + userId.toString()
        const formattedId =
          typeof value === "object"
            ? value.siteId.toString() + value.userId.toString()
            : value.toString();
        if (
          !post_form_data.value.formUserGlobalModelDummy.userIds.includes(
            formattedId
          )
        ) {
          post_form_data.value.formUserGlobalModelDummy.userIds.push(
            formattedId
          );
        }
      });
      // Force reactivity
      post_form_data.value.formUserGlobalModelDummy.userIds = [
        ...post_form_data.value.formUserGlobalModelDummy.userIds,
      ];
    };
    const checkEvents = async (events) => {
      events.forEach((value, index) => {
        post_form_data.value.formEventGlobalModel.eventIds.push(value.eventId);
      });
    };
    const checkSites = async (sites) => {
      sites.forEach((value, index) => {
        post_form_data.value.formSiteGlobalModel.siteIds.push(value.webId);
      });
      getAllFormUsersAndRoles();
    };
    const getFormSites = async (form_webId) => {
      await getLookups("site/siteForms/" + form_webId + "/sites")
        .then((res: any) => {
          allSelectedFormSites.value = res.content;
          checkSites(allSelectedFormSites.value);
        })
        .catch((err) => {
          return [];
        });
    };
    const getFormEvents = async (event_webId) => {
      await getLookups(
        "notification/eventForms/" +
          event_webId +
          "/events?status=ACTIVE&subType=form"
      )
        .then((res: any) => {
          checkEvents(res.content);
        })
        .catch((err) => {
          return [];
        });
    };
    const getFormCategory = async (event_webId) => {
      await getLookups("forms/categories?formDefinitionId=" + event_webId + "")
        .then((res: any) => {
          checkCategories(res.content);
        })
        .catch((err) => {
          return [];
        });
    };
    const getFormRoles = async (event_webId) => {
      await getLookups("forms/roles?formDefinitionId=" + event_webId + "")
        .then((res: any) => {
          checkRoles(res.content);
        })
        .catch((err) => {
          return [];
        });
    };
    // getFormSection
    const getFormSection = async (event_webId) => {
      await getLookups(
        "forms/definitionSections?formDefinitionId=" +
          event_webId +
          "&status=ACTIVE"
      )
        .then((res: any) => {
          // push sectionId and locationId to sectionLocation
          sectionLocation.value = [];
          res.content.forEach((value, index) => {
            sectionLocation.value.push({
              sectionId: value.formSectionId,
              siteId: value.siteId,
              locationId: value.locationId,
            });
          });
          checkSections(res.content);
        })
        .catch((err) => {
          return [];
        });
    };
    const checkSections = (sections) => {
      // sections.forEach((value, index) => {
      //   post_form_data.value.formSiteGlobalModel.siteIds.push(value.webId);
      // });
      sections.forEach((value, index) => {
        const webIdExists = list1.value.some(
          (existingValue) => existingValue.webId === value.webId
        );
        // console.log("webIdExists", webIdExists);
        if (!webIdExists) {
          list1.value.push(value);

          list1.value.sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
          const filteredSections = computed(() => {
            const seletedItems = list1.value.map((item) => item.formSectionId);
            return list2.value.filter(
              (item) => !seletedItems.includes(item.webId)
            );
          });
          list2.value = filteredSections.value;
        }
      });

      // sections.forEach((value, index) => {
      //   list1.value.push(value);
      // });
      movedListSearch.value = [...list1.value];
    };
    const checkFirstScreenBooleans = async (locationRestrict, sequence) => {
      first_screen_booleans.value = [];
      if (locationRestrict) {
        first_screen_booleans.value.push("locationRestrict");
      } else {
        delete first_screen_booleans.value["locationRestrict"];
      }
      if (sequence) {
        first_screen_booleans.value.push("sequence");
      } else {
        delete first_screen_booleans.value["sequence"];
      }
    };
    //dragEnd
    const dragEnd = async (e) => {
      // e.item.classList.remove("bg-light-warning");
      [...e.items, e.item].forEach((element) => {
        element.classList.remove("bg-light-warning");
        element.classList.add("warning");
      });
    };
    const moveTo = () => {
      const items = list2.value.filter((item) =>
        sectionMoveSelected.value.includes(item.webId)
      );
      checkSections(items);
      list2.value
        .filter((item) => sectionMoveSelected.value.includes(item.webId))
        .forEach((x) => list2.value.splice(list2.value.indexOf(x), 1));
      sectionMoveSelected.value = [];
    };
    //moveBack
    const moveBack = () => {
      const items = list1.value.filter((item) =>
        sectionBackSelected.value.includes(item.webId)
      );
      items.forEach((value, index) => {
        list2.value.push(value);
        getLocationName(value.locationId);
      });
      list1.value
        .filter((item) => sectionBackSelected.value.includes(item.webId))
        .forEach((x) => list1.value.splice(list1.value.indexOf(x), 1));
      sectionBackSelected.value = [];
    };
    //addToSelectionMove
    const addToSelectionMove = (webId) => {
      const index = sectionMoveSelected.value.findIndex(
        (item) => webId === item
      );
      if (index > -1) {
        sectionMoveSelected.value.splice(index, 1);
      } else {
        sectionMoveSelected.value.push(webId);
      }
    };
    //addBackSelectionMove
    const addBackSelectionMove = (webId) => {
      const index = sectionBackSelected.value.findIndex(
        (item) => webId === item
      );
      if (index > -1) {
        sectionBackSelected.value.splice(index, 1);
      } else {
        sectionBackSelected.value.push(webId);
      }
    };
    //changeAvailableSection
    const changeAvailableSection = (e) => {
      moveTo();
    };

    const searchSectionFilters = () => {
      searchableFilterList.value = movedListSearch.value;
      if (searchSections.value != "") {
        savedFilterList.value = searchableFilterList.value.filter((item) =>
          item.name
            .trim()
            .toLowerCase()
            .includes(searchSections.value.trim().toLowerCase())
        );
        nextTick(() => {
          MenuComponent.reinitialization();
        });
        list1.value = savedFilterList.value;
      } else {
        list1.value = movedListSearch.value;
      }
    };
    const openLocationModal = async (element) => {
      sectionSelectedForLocation.value = element.webId;
      userSiteModelData.value = {
        ...userSiteModelData.value,
        edit: !!element.locationId,
        data: {
          siteId: element.siteId || "",
          locationId: `${element.locationId}` || "",
          locationRestriction: element.locationRestriction,
        },
      };
      locationOption.value = [];
      if (element.locationId) {
        await handleSiteChange(element.siteId);
      }
      showAddLocationModal.value = true;
      const modal = new Modal(
        document.getElementById(
          "vz-add-edit-modal-add_edit_form_section_location_modal"
        ) as HTMLElement
      );
      modal.show();
    };
    const handleSiteChange = async (siteId) => {
      if (siteId) {
        locationOption.value = [];
        await fetchLocationsList(siteId);
        await nextTick();
      }
    };
    const submitSiteRole = (req) => {
      // findIndex based on sectionSelectedForLocation in list1
      if (sectionSelectedForLocation.value) {
        const index = list1.value.findIndex(
          (item) => item.webId === sectionSelectedForLocation.value
        );
        if (index > -1) {
          list1.value[index].siteId = req.siteId;
          list1.value[index].locationId = req.locationId;
          list1.value[index].locationName = getLocationName(req.locationId);
          sectionLocation.value.push({
            sectionId:
              list1.value[index]?.formSectionId ??
              sectionSelectedForLocation.value,
            // siteId: req.siteId,
            ...req,
          });
          sectionSelectedForLocation.value = undefined;
        }
      }
      showAddLocationModal.value = false;
    };
    const getLocationName = (id) => {
      const location = locationOption.value.find((item) => item.value == id);
      return location ? location.label : "";
    };
    watch(
      singleFormToEdit,
      async (val) => {
        // console.log("hello", val);
        resetAllFormValues();
        resetForm();
        if (val.webId == 1) {
          edit_form.value = false;
        } else {
          edit_form.value = true;
        }
        sectionMoveSelected.value = [];
        sectionBackSelected.value = [];
        await nextTick();
        currentStepIndex.value = 1;
        _stepperObj.value?.goto(1);
        post_form_data.value.webId = val.webId;
        post_form_data.value.name = val.name;
        post_form_data.value.startDate = FormatMethods.convertUTCToLocalDate(
          val.startDate,
          "YYYY-MM-DD"
        );
        post_form_data.value.endDate = FormatMethods.convertUTCToLocalDate(
          val.endDate,
          "YYYY-MM-DD"
        );
        post_form_data.value.locationRestrict = val.locationRestrict;
        post_form_data.value.frequency = `${val.frequency}`;
        post_form_data.value.status =
          val.status.charAt(0).toUpperCase() +
          val.status.slice(1).toLowerCase();
        await getFormSites(val.webId);
        await getFormEvents(val.webId);
        await getFormCategory(val.webId);
        await getFormSection(val.webId);
        checkFirstScreenBooleans(val.locationRestrict, val.sequence);
        // Reconstruct role and user IDs from formUsers if available
        if (val.formUserGlobalModel?.formUsers) {
          const formUsers = val.formUserGlobalModel.formUsers;
          post_form_data.value.formRoleGlobalModel.roleIds = Array.from(
            new Set(
              formUsers
                .filter((fu: any) => fu.roleId !== undefined)
                .map((fu: any) => fu.siteId.toString() + fu.roleId.toString())
            )
          );
          post_form_data.value.formUserGlobalModelDummy.userIds = Array.from(
            new Set(
              formUsers
                .filter((fu: any) => fu.userId !== undefined)
                .map((fu: any) => fu.siteId.toString() + fu.userId.toString())
            )
          );
        } else {
          // Fallback to legacy properties if formUsers not present
          post_form_data.value.formUserGlobalModelDummy.userIds =
            val.formUserGlobalModel?.userIds || [];
          post_form_data.value.formRoleGlobalModel.roleIds =
            val.formRoleGlobalModel?.roleIds || [];
          // Ensure uniqueness
          post_form_data.value.formUserGlobalModelDummy.userIds = Array.from(
            new Set(post_form_data.value.formUserGlobalModelDummy.userIds)
          );
          post_form_data.value.formRoleGlobalModel.roleIds = Array.from(
            new Set(post_form_data.value.formRoleGlobalModel.roleIds)
          );
        }
        // Ensure event uniqueness (post-fetch)
        post_form_data.value.formEventGlobalModel.eventIds = Array.from(
          new Set(post_form_data.value.formEventGlobalModel.eventIds)
        );
      },
      { deep: true }
    );

    watch(
      moveAllForward,
      (newValue) => {
        if (newValue) {
          list2.value.forEach((item) => {
            if (!sectionMoveSelected.value.includes(item.webId)) {
              sectionMoveSelected.value.push(item.webId);
            }
          });
        } else {
          sectionMoveSelected.value = [];
        }
      },
      { deep: true }
    );
    const moveAllForwardClicked = () => {
      if (sectionMoveSelected.value.length === list2.value.length) {
        sectionMoveSelected.value = [];
      } else {
        list2.value.forEach((item) => {
          if (!sectionMoveSelected.value.includes(item.webId)) {
            sectionMoveSelected.value.push(item.webId);
          }
        });
      }
    };
    //moveBack
    watch(
      moveAllBackward,
      (newValue) => {
        if (newValue) {
          list1.value.forEach((item) => {
            if (!sectionBackSelected.value.includes(item.webId)) {
              sectionBackSelected.value.push(item.webId);
            }
          });
        } else {
          sectionBackSelected.value = [];
        }
      },
      { deep: true }
    );
    const moveAllBackwardClicked = () => {
      if (sectionBackSelected.value.length === list1.value.length) {
        sectionBackSelected.value = [];
      } else {
        list1.value.forEach((item) => {
          if (!sectionBackSelected.value.includes(item.webId)) {
            sectionBackSelected.value.push(item.webId);
          }
        });
      }
    };

    return {
      // Methods
      checkUsers,
      checkRoles,
      checkCategories,
      checkFirstScreenBooleans,
      first_screen_booleans,
      checkLocationBoolean,
      getAllFormEvents,
      getAllFormUsersAndRoles,
      getAllFormSites,
      getAllFormSections,
      t,
      post_form_data,
      allSelectedFormSites,
      loading,
      allFormSections,
      loadingUsers,
      searchTermEvents,
      searchTermRoles,
      searchTermUsers,
      searchTermSites,
      searchTermSections,
      allFormEvents,
      allFormUsersFilter,
      allFormRolesFilter,
      sitesKeyword,
      allFormSites,
      startDate,
      targetCategories,
      handleStep,
      formSubmit,
      previousStep,
      createAppRef,
      currentStepIndex,
      totalSteps,
      selectAllSites,
      //createAppModalRef,
      createEventModalRef,
      getIllustrationsPath,
      formCategories,
      itemsTemplates,
      itemsReceipents,
      openDetailModal,
      selectedSection,
      selectAll,
      selectAllUsers,
      order,
      list1,
      list2,
      controlOnStart,
      idGlobal,
      clone,
      pullFunction,
      start,
      singleFormToEdit,
      edit_form,
      dragEnd,
      moveTo,
      sectionBackSelected,
      sectionMoveSelected,
      moveBack,
      selectAllEvents,
      addToSelectionMove,
      changeAvailableSection,
      addBackSelectionMove,
      searchSectionFilters,
      searchSections,
      moveAllForward,
      moveAllForwardClicked,
      moveAllBackward,
      frequencyOptions,
      filterFormRoles,
      filterFormUsers,
      closeModal,
      displayDate,
      format,
      moveToSpecificStep,
      isValid,
      openLocationModal,
      computedUserSiteModalData,
      showAddLocationModal,
      submitSiteRole,
      checkSequenceFormBoolean,
      getLocationName,
      sectionLocation,
      submitButton,
      showDetailDialog,
      statusOptions,
      minEndDate,
      moveAllBackwardClicked,
      selectedSiteOptions,
      userSiteModelData,
      fetchLocationsList,
      locationOption,
      handleSiteChange,
    };
  },
});
